import { createSelector } from "reselect";
export const selectUserInfos = state => state.userInfos || {};

export const selectUserKpis = createSelector([selectUserInfos], (userInfos = {}) => {
  return userInfos.kpis;
});

export const selectUserRoleId = createSelector([selectUserInfos], (userInfos = {}) => {
  return userInfos.role_id || 100;
});

export const selectUserKpisIds = createSelector([selectUserKpis], (kpis = []) => {
  return kpis.map(v => v.id);
});

export const selectUserClients = createSelector([selectUserInfos], (userInfos = {}) => {
  const clients = userInfos.clients || [];
  return clients.map(client => ({ client_id: client.id, client_label: client.label }));
});

export const selectUserSectorsId = createSelector([selectUserInfos], (userInfos = {}) => {
  const sectors = userInfos.sectors || [];
  return sectors.map(sector => sector.sector_id);
});



// WEBPACK FOOTER //
// src/redux/selectors/user.js